export default {
  id: 'CreateClassroom',
  code: 'CN',
  text: {
    'Create Classroom': '新增教室',
    'Edit Classroom': '编辑教室',
    'Class Name': '教室名称',
  }
}



// WEBPACK FOOTER //
// ./src/template/Modals/CreateClassroom/locale.js